import {
    Box, Skeleton, SxProps, Theme,
} from '@mui/material';
import { useEffect, useState } from 'react';

type LoadingStateImageProps = {
    src?: string;
    imageSx?: SxProps<Theme>;
    skeletonWidth?: number;
    skeletonHeight?: number;
};

export const LoadingStateImage = ({
    src, imageSx, skeletonWidth = 500, skeletonHeight = 400,
}: LoadingStateImageProps): JSX.Element => {
    const [imageLoading, setImageLoading] = useState(true);

    useEffect(() => {
        setImageLoading(true);
    }, [src]);

    return src ? (
        <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ position: 'relative', display: 'inline-block', maxWidth: '100%' }}>
                {imageLoading && (
                    <Skeleton
                        animation="wave"
                        height={skeletonHeight}
                        sx={{ borderRadius: 1 }}
                        variant="rectangular"
                        width={skeletonWidth}
                    />
                )}
                {!imageLoading && (
                    <Box
                        component="img"
                        src={src}
                        sx={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            height: 'auto',
                            ...imageSx,
                        }}
                        onLoad={(): void => setImageLoading(false)}
                    />
                )}
                {imageLoading && (
                    <Box
                        component="img"
                        src={src}
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            opacity: 0,
                            pointerEvents: 'none',
                        }}
                        onLoad={(): void => setImageLoading(false)}
                    />
                )}
            </Box>
        </Box>
    ) : (
        <Box
            sx={{
                border: '1px dashed',
                borderColor: 'divider',
                borderRadius: 1,
                p: 2,
                textAlign: 'center',
                color: 'text.secondary',
                width: 400,
                height: 300,
            }}
        >
            No image to show
        </Box>
    );
};
